import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCombine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17_33)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 0C6.89543 0 6 0.89543 6 2V6H2C0.89543 6 0 6.89543 0 8V18C0 19.1046 0.89543 20 2 20H12C13.1046 20 14 19.1046 14 18V14H18C19.1046 14 20 13.1046 20 12V2C20 0.89543 19.1046 0 18 0H8ZM12 14H14V10L12.5 6.5C12.5 5.6147 9.03408 5.82732 7.08932 5.94663C6.60764 5.97618 6.21927 6 6 6V8H2V18H12V14ZM12 14V11V8H6V12C6 13.1046 6.89543 14 8 14H12Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6 6V8H12V11V14H14V10L12.5 6.5C12.5 5.6147 9.03408 5.82732 7.08932 5.94663C6.60764 5.97618 6.21927 6 6 6Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17_33",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgCombine;
